export default "__VITE_ASSET__CkKbAz6K__"